module.exports = __webpack_public_path__ + "static/media/DK-2037.d7469011.png";